<template>
  <nav>
    <div class="container mobile">
      <input id="responsive-menu" type="checkbox" />
      <label for="responsive-menu">
        <img class="brand-wave" src="@/assets/logo_sq_bg.svg"/>
        <span> Rektproof </span>
        <span id="menu-icon"></span
      ></label>
      <div id="overlay"></div>
      <ul class="menu-label">
        RektProof Education
      </ul>
      <ul class="menu-list">
        <li>
          <router-link :to="{ name: 'EducationPDFLessons' }"
            >Lessons</router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'KozHubVideos' }">Video Lessons</router-link>
        </li>
        <li v-if="!lessonsOnly && admin">
          <router-link :to="{ name: 'EducationExams' }">Exams</router-link>
        </li>
      </ul>
      <template v-if="!lessonsOnly && (admin || staff)">
        <ul class="menu-label">
          Membership
        </ul>
        <ul class="menu-list">
          <li>
            <router-link :to="{ name: 'MembershipPlans' }">Plans</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'MembershipMembers' }"
              >Members</router-link
            >
          </li>
          <li v-if="admin">
            <router-link :to="{ name: 'MembershipWaitlist' }"
              >Waitlist</router-link
            >
          </li>
        </ul>
      </template>
      <template v-if="!lessonsOnly && admin">
        <ul class="menu-label">
          Settings
        </ul>
        <ul class="menu-list">
          <li>
            <router-link :to="{ name: 'SettingsStaff' }">Staff</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'SettingsMembers' }">Members</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'SettingsWaitlist' }"
            >Waitlist</router-link
            >
          </li>
          <li>
            <router-link :to="{ name: 'SettingsDiscount' }"
            >Discount</router-link
            >
          </li>
          <li>
            <router-link :to="{ name: 'SettingsPayments' }"
            >Payments</router-link
            >
          </li>
        </ul>
        <ul class="menu-label">
          Transactions
        </ul>
        <ul class="menu-list">
          <li>
            <router-link :to="{ name: 'TransactionsPayments' }"
            >BTC Payments</router-link
            >
          </li>
          <li>
            <router-link :to="{ name: 'TransactionsPaymentsUSDT' }"
            >USDT Payments</router-link
            >
          </li>
        </ul>
      </template>
      <ul class="menu-label">
        Account
      </ul>
      <ul class="menu-list">
        <template v-if="!lessonsOnly">
          <li>
            <router-link :to="{ name: 'AccountMyAccount' }"
              >My Account</router-link
            >
          </li>
          <li>
            <router-link :to="{ name: 'AccountMyNotes' }">My Notes</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'AccountMyTradeJournals' }"
              >My Trade Journals</router-link
            >
          </li>
          <li>
            <router-link :to="{ name: 'AccountCalculators' }"
            >Calculators</router-link
            >
          </li>
        </template>
        <li><a @click="logout()">Log out</a></li>
      </ul>
    </div>
  </nav>
</template>
<script>
import { auth } from "@/firebase";
import { mapState } from "vuex";
import ButtonDarkMode from "./buttonDarkMode.vue";
export default {
  data() {
    return {
      admin: false,
      staff: false,
      lessonsOnly: false,
    };
  },
  computed: {
    ...mapState(["userProfile"]),
  },
  async created() {
    const idTokenResult = await auth.currentUser.getIdTokenResult();
    this.admin = !!idTokenResult.claims.admin;
    this.staff = !!idTokenResult.claims.staff;
    this.lessonsOnly =
      idTokenResult.claims.access_scope === "lessons" ||
      this.userProfile?.access_scope === "lessons" ||
      !!this.userProfile?.isWhopLessons;
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
  components: { ButtonDarkMode },
};
</script>
<style>
span {
  color: var(--text-primary-color);
}
</style>
